import { render, staticRenderFns } from "./AnswerCard.vue?vue&type=template&id=61fdcfba&scoped=true"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"
import style0 from "./AnswerCard.vue?vue&type=style&index=0&id=61fdcfba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fdcfba",
  null
  
)

export default component.exports